;
$(document).ready(function(){
	//var array_tipos = ['placa','email','telefono','operador'];
	$("#placa_circulo").removeClass('circulo_numero-inactive');
	$("#placa_circulo").addClass('circulo_numero-active');
	$("#placa").removeClass('custom-input-inner-inactive');
	$("#placa").addClass('custom-input-inner-active');
	$("#placa").attr('disabled', false);
	$("#placa").focus();
	var placa_input = $("#placa").closest('.custom-input-inactive');
	placa_input.removeClass('custom-input-inactive');
	placa_input.addClass('custom-input-active');
	var contador_operadores = 1;
	var email_correcto = false;
	var telefono_correcto = false;
	var x=0;

	$("#btn_agregar_operador").click(function(){
		var operador_html="";
		var agregar = validarDatosOperadorOk(true);

		if(agregar){
			operador_html+='<div class="col-12 operadores_col mt-4" id="operador_'+contador_operadores+'">';
			operador_html+='<div class="row d-flex justify-content-center">';
			operador_html+='<div class="col-lg-5 col-12 offset-1">';
			operador_html+='<div class="row d-flex justify-content-center">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-color-verde-pino bold">CURP*</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="custom-input-active width-100 row">';
			operador_html+='<div class="col-9 col-sm-10 col-md-10 col-lg-8 col-xl-10">';
			operador_html+='<input id="curp_operador_'+contador_operadores+'" class="ml-1 pl-0 custom-input-inner-active width-100 operadores_curp"/>';
			operador_html+='</div>';
			operador_html+='<div class="col-3 col-sm-2 col-md-2 col-lg-4 col-xl-2">';
			operador_html+='<img id="curp_operador_img_'+contador_operadores+'" class="mt-2" src=""/>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="row d-none" id="row_error_operador_'+contador_operadores+'">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-danger bold">CURP no registrado</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="col-lg-5 col-12 offset-1 mt-3 mt-lg-0">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-color-verde-pino bold">Nombre*</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="custom-input-active width-100 row">'
			operador_html+='<div class="col-9 col-sm-10 col-md-10 col-lg-8 col-xl-10">';
			operador_html+='<input id="nombre_operador_'+contador_operadores+'" class="ml-1 pl-0 custom-input-inner-active width-100 operadores_nombre" />';
			operador_html+='</div>';
			operador_html+='<div class="col-3 col-sm-2 col-md-2 col-lg-4 col-xl-2">';
			operador_html+='<img id="nombre_operador_img_'+contador_operadores+'" class="mt-2" src=""/>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="d-none" id="row_error_operador_nombre_'+contador_operadores+'">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-danger bold">Nombre es obligatorio</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			//boton eliminar

			operador_html+='</div>';
			operador_html+='<div class="row d-flex justify-content-center">';
			operador_html+='<div class="col-lg-5 col-12 offset-1 mt-3 mt-lg-0">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-color-verde-pino bold">Primer apellido</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="custom-input-active width-100 row">'
			operador_html+='<div class="col-9 col-sm-10 col-md-10 col-lg-8 col-xl-10">';
			operador_html+='<input id="p_apellido_operador_'+contador_operadores+'" class="ml-1 pl-0 custom-input-inner-active width-100 operadores_p_apellido"/>';
			operador_html+='</div>';
			operador_html+='<div class="col-3 col-sm-2 col-md-2 col-lg-4 col-xl-2">';
			operador_html+='<img id="p_apellido_operador_img_'+contador_operadores+'" class="mt-2" src=""/>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="col-lg-5 col-12 offset-1 mt-3 mt-lg-0">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<p class="text-color-verde-pino bold">Segundo apellido</p>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="row">';
			operador_html+='<div class="col-12">';
			operador_html+='<div class="custom-input-active width-100 row">';
			operador_html+='<div class="col-9 col-sm-10 col-md-10 col-lg-8 col-xl-10">';
			operador_html+='<input id="s_apellido_operador_'+contador_operadores+'" class="ml-1 pl-0 custom-input-inner-active width-100 operadores_s_apellido" />';
			operador_html+='</div>';
			operador_html+='<div class="col-3 col-sm-2 col-md-2 col-lg-4 col-xl-2">';
			operador_html+='<img id="s_apellido_operador_img_'+contador_operadores+'" class="mt-2" src=""/>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='<div class="col-12 mt-3"">';
			operador_html+='<div class="circulo_quitar bold cursor-pointer quitar_operador float-right" id="quitar_operador_'+contador_operadores+'">x';
			operador_html+='</div>';
			operador_html+='</div>';
			operador_html+='</div>';

			$("#operadores_container").append(operador_html);
			contador_operadores++;
			$("#btn_registrar").addClass('btn-general-inactive');
			$("#btn_registrar").removeClass('btn-general-active');
			$("#btn_registrar").attr('disabled', true);
		}else{
			crearMensaje(true,"Error","No puede agregar más operadores a menos que todos los agregados esten correctos");
		}
	});


	/*funcionamiento de busqueda cada segundo que el usuario teclea en un campo*/


	$("input[name=concesion_radio]").change(function(){
		var placa = $("#placa").val();
		buscarTermino(placa,'placa');
	});



	$("#radio_agregar").attr("disabled",true);
	$("#radio_eliminar").attr("disabled",true);
	$("input[name=operador_radio]").change(function(){
		var operadores = $(".operadores_curp");
		for(let i=0;i<operadores.length;i++){
			valor = operadores[i].value;
			id = operadores[i].id;
			num_operador =  id.split("_")[2];
			buscarTermino(valor,'operador',num_operador);
		}

	});


	sessionStorage.setItem("last_input_time_placa",null);
	$("#placa").val('');
	$(document).on('input','#placa',function(){
		var placa = $(this).val();
		placa = placa.replace(/[^0-9A-Za-zñÑ]/g,'');
		$("#placa").val(placa);
		var last_input_time = sessionStorage.getItem("last_input_time_placa");
		if(last_input_time==null){
			sessionStorage.setItem("last_input_time_placa", setTimeout(function(){
				buscarTermino(placa,'placa');
			},1000));
		}else{
			clearTimeout(last_input_time);
			sessionStorage.setItem("last_input_time_placa", setTimeout(function(){
			buscarTermino(placa,'placa');
			},1000));
		}
	});


	$("#email").val('');
	$(document).on('input','#email',function(){
		var email = $(this).val();
		email = email.replace(/\s/g,'');
		$("#email").val(email);

		if(email.length==0 && telefono_correcto==true){
			$('#email_img').attr('src',base_url+"/images/check_mark.svg");
		  	$("#row_error_email").addClass('d-none');
		    email_correcto = true;
			desbloquearPaso3();
		}else{
			var regex_email = RegExp('^[^@\/]+@[^@\/]+$');

			if(regex_email.test(email) || (email.length==0 && telefono_correcto)){
				$('#email_img').attr('src',base_url+"/images/check_mark.svg");
			  	$("#row_error_email").addClass('d-none');
			    email_correcto = true;
			    var tam_telefono = $("#telefono").val();
			    tam_telefono = tam_telefono.length;
			    if(tam_telefono==0 || tam_telefono==10){
			    	telefono_correcto=true;
			    	$('#email_img').attr('src',base_url+"/images/check_mark.svg");
			  	$("#row_error_telefono").addClass('d-none');
				$('#telefono_img').attr('src',base_url+"/images/check_mark.svg");
				desbloquearPaso3();
			    }
			}else{
				email_correcto = false;
				bloquearCampos('email',null);
			}

		}
	});

	$("#telefono").val('');
	$(document).on('input','#telefono',function(){
		var telefono = $(this).val();
		telefono = telefono.replace(/[^0-9]/g,'');
		$("#telefono").val(telefono);
		if(telefono.length==0 && email_correcto ){
			$('#telefono_img').attr('src',base_url+"/images/check_mark.svg");
		  	$("#row_error_telefono").addClass('d-none');
		    telefono_correcto = true;
			desbloquearPaso3();
		}else{
			if(telefono.length == 10 || (telefono.length==0 && email_correcto)){
				telefono_correcto=true;
				$('#telefono_img').attr('src',base_url+"/images/check_mark.svg");
			  	$("#row_error_telefono").addClass('d-none');
			    telefono_correcto = true;
			    var tam_email = $("#email").val();
			    tam_email = tam_email.length;
			    var regex_email = RegExp('^[^@\/]+@[^@\/]+$');
			    if(tam_email==0 || regex_email.test($("#email").val())){
			    	email_correcto = true;
			    	$('#email_img').attr('src',base_url+"/images/check_mark.svg");
			  		$("#row_error_email").addClass('d-none');
					desbloquearPaso3();
			    }
			}else{
				telefono_correcto = false;
				bloquearCampos('telefono',null);
			}

		}
	});


	$(".operadores_curp").val('');
	$(".operadores_nombre").val('');
	$(".operadores_p_apellido").val('');
	$(".operadores_s_apellido").val('');
	sessionStorage.setItem("last_input_time_operador",null);
	$(document).on('input','.operadores_curp',function(){
		$(this).removeClass('operador_ok');
		var curp = $(this).val();
		curp = curp.replace(/[^0-9A-Za-zñÑ]/g,'');
		$(this).val(curp);
		var id_operador = $(this).attr('id');
		var operadores = $(".operadores_curp");
		var existe_operador = false;
		var operador_conteo=1;
		for(var i=0;i<operadores.length;i++){
			var valor = operadores[i].value;
			var id = operadores[i].id;
			var num_operador = id.split("_")[2];

			if(id_operador!=id && curp==valor && $("#operador_"+num_operador).hasClass("operador_ok")){
				//if(operador_conteo > 1){
					existe_operador = true;
					break;
				//}
				//operador_conteo++;
			}
		}

		if(!existe_operador){

			var id = $(this).attr('id');
			var num_operador = id.split("_")[2];
			var last_input_time = sessionStorage.getItem("last_input_time_operador");
			if(last_input_time==null){
				sessionStorage.setItem("last_input_time_operador", setTimeout(function(){
					buscarTermino(curp,'operador',num_operador);
				},1000));
			}else{
				clearTimeout(last_input_time);
				sessionStorage.setItem("last_input_time_operador", setTimeout(function(){
				buscarTermino(curp,'operador',num_operador);
				},1000));
			}
		}else{
			crearMensaje(true,"Error","No puedes agregar/eliminar al mismo usuario más de una vez");
		}
	});

	$(document).on('input','.operadores_nombre',function(){
		var nombre = $(this).val();
		var id = $(this).attr('id');
		var num_operador = id.split("_")[2];

		if(nombre.length>0){
			$("#row_error_operador_nombre_"+num_operador).addClass("d-none");
			$("#nombre_operador_img_"+num_operador).attr('src',base_url+"/images/check_mark.svg");
		}else{
			$("#row_error_operador_nombre_"+num_operador).removeClass('d-none');
			$("#nombre_operador_img_"+num_operador).attr('src',base_url+"/images/error_mark.svg");
		}
		validarDatosOperadorOk();
	});

	$(document).on('input','.operadores_p_apellido',function(){
		var p_apellido = $(this).val();
		var id = $(this).attr('id');
		var num_operador = id.split("_")[3];

		if(p_apellido.length==0 && $("#s_apellido_operador_"+num_operador
			).val().length==0){
			$("#p_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/error_mark.svg");

			$("#s_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/error_mark.svg");
			crearMensaje(true,"Error","Al menos debes llenar un campo de los apellidos");
		}else {
			$("#p_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/check_mark.svg");
			$("#s_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/check_mark.svg");
		}
		validarDatosOperadorOk();
	});

	$(document).on('input','.operadores_s_apellido',function(){
		var s_apellido = $(this).val();
		var id = $(this).attr('id');
		var num_operador = id.split("_")[3];

		if(s_apellido.length==0 && $("#p_apellido_operador_"+num_operador
			).val().length==0){
			$("#p_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/error_mark.svg");

			$("#s_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/error_mark.svg");
			crearMensaje(true,"Error","Al menos debes llenar un campo de los apellidos");
		}else {
			$("#p_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/check_mark.svg");
			$("#s_apellido_operador_img_"+num_operador).attr('src',base_url+"/images/check_mark.svg");
		}
		validarDatosOperadorOk();
	});

	function buscarTermino(termino,id,num_operador=null){

		var concesion_radio = $("input[name=concesion_radio]");
		var concesion_radio_val = concesion_radio.filter(":checked").val();
		var operador_radio = $("input[name=operador_radio]");
		var operador_radio_val = operador_radio.filter(":checked").val();

		$.get(base_url+'/buscarTermino?termino='+termino+'&tipo='+id+'&vehiculo='+concesion_radio_val+"&operador="+operador_radio_val, function(data, textStatus, xhr) {

			bloquearCampos(id,num_operador);
			if(textStatus === 'success' && data.code==200){
				switch(id) {
				  	case 'placa':
					  	$('#placa_img').attr('src',base_url+"/images/check_mark.svg");
					  	$("#row_error_placa").addClass('d-none');
					    $("#datos_contacto_circulo").removeClass('circulo_numero-inactive');
						$("#datos_contacto_circulo").addClass('circulo_numero-active');

						$("#email").removeClass('custom-input-inner-inactive');
						$("#email").addClass('custom-input-inner-active');
						$("#email").attr('disabled', false);
						$("#telefono").removeClass('custom-input-inner-inactive');
						$("#telefono").addClass('custom-input-inner-active');
						$("#telefono").attr('disabled', false);
						var email_input = $("#email").closest('.custom-input-inactive');
						email_input.removeClass('custom-input-inactive');
						email_input.addClass('custom-input-active');
						var telefono_input = $("#telefono").closest('.custom-input-inactive');
						telefono_input.removeClass('custom-input-inactive');
						telefono_input.addClass('custom-input-active');
						$("#email").focus();
					    break;

				  	case 'operador':
					  	$('#curp_operador_img_'+num_operador).attr('src',base_url+"/images/check_mark.svg");
					  	$("#row_error_operador_"+num_operador).addClass('d-none');
					  	$("#operador_"+num_operador).addClass("operador_ok");
					  	$("#nombre_operador_"+num_operador).focus();
					  	validarDatosOperadorOk();
					  	break;
				  	default:
				  		break;

				}
			}else if(textStatus === 'success' && data.code==204){
				//crearMensaje(true,"Error",data.response);
			}else if(textStatus === 'success' && data.code==400){
				if(data.response!='Faltan parámetros'){
					crearMensaje(true,"Error",data.response);
				}
			}else{
				crearMensaje(true,"Sin resultados","Error en la carga de datos");
			}
		});
	}

	function bloquearCampos(id,id_operador){

		switch(id) {
			case 'placa':
				$("#row_error_placa").removeClass('d-none');
				$("#placa_img").attr('src',base_url+"/images/error_mark.svg");
				bloquearPaso2();
				bloquearPaso3();
				break;
			case 'email':
				email_correcto =false;
				$("#row_error_email").removeClass('d-none');
				$("#email_img").attr('src',base_url+"/images/error_mark.svg");
				if($("#telefono").val().length==0){
					$("#telefono_img").attr("src","");
					$("#row_error_telefono").addClass('d-none');
				}
				bloquearPaso3();
				break;
			case 'telefono':
				telefono_correcto = false;
				$("#row_error_telefono").removeClass('d-none');
				$("#telefono_img").attr('src',base_url+"/images/error_mark.svg");
				if($("#email").val().length==0){
					$("#email_img").attr("src","");
					$("#row_error_email").addClass('d-none');
				}
				bloquearPaso3();
				break;
			case 'operador':
				$("#curp_operador_img_"+id_operador).attr('src',base_url+"/images/error_mark.svg");
				$("#row_error_operador_"+id_operador).removeClass('d-none');
				break;

		}
		$("#btn_registrar").addClass('btn-general-inactive');
		$("#btn_registrar").removeClass('btn-general-active');
		$("#btn_registrar").attr('disabled', true);
	}

	function bloquearPaso2(){
		$("#datos_contacto_circulo").removeClass('circulo_numero-active');
		$("#datos_contacto_circulo").addClass('circulo_numero-inactive');
		$("#email").addClass('custom-input-inner-inactive');
		$("#email").removeClass('custom-input-inner-active');
		$("#email").attr('disabled', true);
		$("#email").val('');
		$("#email_img").attr("src","");
		$("#row_error_email").addClass("d-none");
		$("#telefono").addClass('custom-input-inner-inactive');
		$("#telefono").removeClass('custom-input-inner-active');
		$("#telefono").attr('disabled', true);
		$("#telefono").val();
		$("#telefono_img").attr("src","");
		$("#row_error_telefono").addClass("d-none");
		var email_input = $("#email").closest('.custom-input-active');
		email_input.addClass('custom-input-inactive');
		email_input.removeClass('custom-input-active');
		var telefono_input = $("#telefono").closest('.custom-input-active');
		telefono_input.addClass('custom-input-inactive');
		telefono_input.removeClass('custom-input-active');
	}

	function bloquearPaso3(){
		$("#radio_agregar").attr("disabled",true);
		$("#radio_eliminar").attr("disabled",true);
		$("#row_agregar_operador").addClass('d-none');
		$("#datos_operador_circulo").removeClass('circulo_numero-active');
		$("#datos_operador_circulo").addClass('circulo_numero-inactive');
		$("#row_error_operador_0").addClass('d-none');

		//curp
		$("#curp_operador_0").addClass('custom-input-inner-inactive');
		$("#curp_operador_0").removeClass('custom-input-inner-active');
		$("#curp_operador_0").attr('disabled', true);
		$("#curp_operador_0").val('');
		$("#curp_operador_img_0").attr("src","");
		var curp_operador_0_input = $("#curp_operador_0").closest('.custom-input-active');
		curp_operador_0_input.addClass('custom-input-inactive');
		curp_operador_0_input.removeClass('custom-input-active');

		//nombre
		$("#nombre_operador_0").addClass('custom-input-inner-inactive');
		$("#nombre_operador_0").removeClass('custom-input-inner-active');
		$("#nombre_operador_0").attr('disabled', true);
		$("#nombre_operador_0").val('');
		$("#nombre_operador_img_0").attr("src","");
		var nombre_operador_0_input = $("#nombre_operador_0").closest('.custom-input-active');
		nombre_operador_0_input.addClass('custom-input-inactive');
		nombre_operador_0_input.removeClass('custom-input-active');

		//primer apellido
		$("#p_apellido_operador_0").addClass('custom-input-inner-inactive');
		$("#p_apellido_operador_0").removeClass('custom-input-inner-active');
		$("#p_apellido_operador_0").attr('disabled', true);
		$("#p_apellido_operador_0").val('');
		$("#p_apellido_operador_img_0").attr("src","");
		var p_apellido_operador_0_input = $("#p_apellido_operador_0").closest('.custom-input-active');
		p_apellido_operador_0_input.addClass('custom-input-inactive');
		p_apellido_operador_0_input.removeClass('custom-input-active');

		//segundo apellido
		$("#s_apellido_operador_0").addClass('custom-input-inner-inactive');
		$("#s_apellido_operador_0").removeClass('custom-input-inner-active');
		$("#s_apellido_operador_0").attr('disabled', true);
		$("#s_apellido_operador_0").val('');
		$("#s_apellido_operador_img_0").attr("src","");
		var s_apellido_operador_0_input = $("#s_apellido_operador_0").closest('.custom-input-active');
		s_apellido_operador_0_input.addClass('custom-input-inactive');
		s_apellido_operador_0_input.removeClass('custom-input-active');

		var operadores = $(".operadores_col");
		for(let i =0;i< operadores.length;i++){
			let id = operadores[i].id;
			let num_operador = id.split("_")[1];
			if(id!="operador_0"){
				$("#operador_"+num_operador).remove();
			}
		}

	}

	function desbloquearPaso3(){
		$("#radio_agregar").attr("disabled",false);
		$("#radio_eliminar").attr("disabled",false);
		$("#row_agregar_operador").removeClass('d-none');
		$("#datos_operador_circulo").addClass('circulo_numero-active');
		$("#datos_operador_circulo").removeClass('circulo_numero-inactive');

		//curp
		$("#curp_operador_0").removeClass('custom-input-inner-inactive');
		$("#curp_operador_0").addClass('custom-input-inner-active');
		$("#curp_operador_0").attr('disabled', false);
		var curp_operador_0_input = $("#curp_operador_0").closest('.custom-input-inactive');
		curp_operador_0_input.removeClass('custom-input-inactive');
		curp_operador_0_input.addClass('custom-input-active');

		//nombre
		$("#nombre_operador_0").removeClass('custom-input-inner-inactive');
		$("#nombre_operador_0").addClass('custom-input-inner-active');
		$("#nombre_operador_0").attr('disabled', false);
		var nombre_operador_0_input = $("#nombre_operador_0").closest('.custom-input-inactive');
		nombre_operador_0_input.removeClass('custom-input-inactive');
		nombre_operador_0_input.addClass('custom-input-active');

		//primer apellido
		$("#p_apellido_operador_0").removeClass('custom-input-inner-inactive');
		$("#p_apellido_operador_0").addClass('custom-input-inner-active');
		$("#p_apellido_operador_0").attr('disabled', false);
		var p_apellido_operador_0_input = $("#p_apellido_operador_0").closest('.custom-input-inactive');
		p_apellido_operador_0_input.removeClass('custom-input-inactive');
		p_apellido_operador_0_input.addClass('custom-input-active');

		//segundo apellido
		$("#s_apellido_operador_0").removeClass('custom-input-inner-inactive');
		$("#s_apellido_operador_0").addClass('custom-input-inner-active');
		$("#s_apellido_operador_0").attr('disabled', false);
		var s_apellido_operador_0_input = $("#s_apellido_operador_0").closest('.custom-input-inactive');
		s_apellido_operador_0_input.removeClass('custom-input-inactive');
		s_apellido_operador_0_input.addClass('custom-input-active');
	}


	$("#btn_registrar").click(function(){
		if($("#checkbox_aviso").is(":checked")){
			var placa = $("#placa").val();
			//var serie = $("#serie").val();
			var email = $("#email").val();
			var telefono = $("#telefono").val();
			var operadores_curp = $('.operadores_curp');
			var operadores_nombre = $('.operadores_nombre');
			var operadores_p_apellido = $('.operadores_p_apellido');
			var operadores_s_apellido = $('.operadores_s_apellido');
			var valores_operadores_curp = "";
			var valores_operadores_nombre = "";
			var valores_operadores_p_apellido = "";
			var valores_operadores_s_apellido = "";
			var concesion_radio = $("input[name=concesion_radio]");
			var vehiculo = concesion_radio.filter(":checked").val();
			var operador_radio = $("input[name=operador_radio]");
			var tipo_registro = operador_radio.filter(":checked").val();

			for(var i=0;i<operadores_curp.length;i++){
				let id =  operadores_curp[i].id;
				let num_operador = id.split("_")[2];
				let curp = operadores_curp[i].value;
				let nombre = operadores_nombre[i].value;
				let p_apellido = operadores_p_apellido[i].value;
				let s_apellido = operadores_s_apellido[i].value;
				if($("#operador_"+num_operador).hasClass("operador_ok")){
					valores_operadores_curp+=curp;
					valores_operadores_nombre+=nombre;
					if(p_apellido==""){
						valores_operadores_p_apellido += "$*..*$"
					}else{
						valores_operadores_p_apellido+=p_apellido;	
					}
					if(s_apellido==""){
						valores_operadores_s_apellido += "$*..*$"
					}else{
						valores_operadores_s_apellido+=s_apellido;	
					}

					if(i!=operadores_curp.length-1){
						valores_operadores_curp+=',';
						valores_operadores_nombre+=',';
						valores_operadores_p_apellido+=',';
						valores_operadores_s_apellido+=',';
					}
				}
			}
			if(valores_operadores_curp[valores_operadores_curp.length-1]==","){
				valores_operadores_curp = valores_operadores_curp.substring(0, valores_operadores_curp.length-1);
			}

			if(valores_operadores_nombre[valores_operadores_nombre.length-1]==","){
				valores_operadores_nombre = valores_operadores_nombre.substring(0, valores_operadores_nombre.length-1);
			}

			if(valores_operadores_p_apellido[valores_operadores_p_apellido.length-1]==","){
				valores_operadores_p_apellido = valores_operadores_p_apellido.substring(0, valores_operadores_p_apellido.length-1);
			}

			if(valores_operadores_s_apellido[valores_operadores_s_apellido.length-1]==","){
				valores_operadores_s_apellido = valores_operadores_s_apellido.substring(0, valores_operadores_s_apellido.length-1);
			}

			if(placa!=""){
				if(email!="" || (email=="" && telefono!="")){
					var regex_email = RegExp('^[^@\/]+@[^@\/]+$');
					if(regex_email.test(email) || (email=="" && telefono!="")){
						if(telefono!="" || (telefono=="" && email!="")){
							telefono = telefono.replace(/[^0-9]/g,'');
							if((telefono=="" && email!="") || telefono.length==10){
								if(valores_operadores_curp.length >0 &&valores_operadores_nombre.length >0 &&(valores_operadores_p_apellido.length >0 || valores_operadores_s_apellido.length >0)){
									$.ajax({
										type: 'POST',
										url: base_url+'/guardarRegistro',
										headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
										data: ({
											placa: placa,
											email: email,
											telefono: telefono,
											vehiculo:vehiculo,
											valores_operadores_curp: valores_operadores_curp,
											valores_operadores_nombre: valores_operadores_nombre,
											valores_operadores_p_apellido: valores_operadores_p_apellido,
											valores_operadores_s_apellido: valores_operadores_s_apellido,
											tipo_registro:tipo_registro
										}),
										success: function(data){
											if(data.code==200){
												location.href = base_url+"/folio";
											}else if(data.code==400 && data.response=="TokenMismatchException"){
												location.href = base_url+"/";
											}else{
												crearMensaje(true,"Error",data.response);
											}
										},
										error: function( jqXhr, textStatus, errorThrown ){
											console.log( errorThrown );
										}
									});
								}else{
									crearMensaje(true,"Error","Nesesitas agregar al menos a 1 operador");
								}
							}else{
								crearMensaje(true,"Error","El campo de telefono debe de tener 10 digitos");
							}
						}else{
							crearMensaje(true,"Error","El campo de telefono es obligatorio");
						}
					}else{
						crearMensaje(true,"Error","El campo de email no tiene la estructura esperada");
					}
				}else{
					crearMensaje(true,"Error","Debe de seleccionar al menos uno de los campos de email o de telefono");
				}
			}else{
				crearMensaje(true,"Error","El campo de placa es obligatorio");
			}
		}else{
			crearMensaje(true,"Error","Debes de aceptar el aviso de privacidad para continuar");
		}
	});



	$(document).on('click','.quitar_operador',function(){
		var id = $(this).attr("id");
		var num_operador = id.split("_")[2];

		$("#operador_"+num_operador).remove();
		validarDatosOperadorOk();

	});


	window.crearMensaje = function (error,titulo,mensaje,tiempo=3000){
		var clase_mensaje = error==true?"alert-danger":"alert-success";
		var mensaje_alert = '<div class="alertaActivacion alert msj_js '+clase_mensaje+'">';
		mensaje_alert += '<strong id="mensaje_negritas" style="font-size:16px;">'+titulo+'</strong>';
		mensaje_alert += '<p id="mensaje" style="font-size:14px;">'+mensaje+'</p>';
		mensaje_alert += '</div>';
		$("body").append(mensaje_alert);
		$(".msj_js").show();
        setTimeout(function(){
        	$(".msj_js").remove();
        }, tiempo);
	}

	function validarDatosOperadorOk(agregar=false){
		var operadores_curp = $(".operadores_col");
		var valido = true;

		//se validan los operadores
		for(let i=0; i< operadores_curp.length;i++){
			var clases = operadores_curp[i].classList;
			if(!clases.contains("operador_ok")){
				valido = false;
				break;
			}
		}

		//se validan los nombres
		var operadores_nombre = $(".operadores_nombre");
		if(valido){
			for(let i=0; i< operadores_nombre.length;i++){
				var valor = operadores_nombre[i].value;
				if(valor.length==0){
					valido = false;
					break;
				}
			}
			//se validan los apellidos
			var operadores_p_apellido = $(".operadores_p_apellido");
			if(valido){
				for(let i=0; i< operadores_p_apellido.length;i++){
					var valor = operadores_p_apellido[i].value;
					var id = operadores_p_apellido[i].id;
					var num_operador = id.split("_")[3];
					if(valor.length==0 && $("#s_apellido_operador_"+num_operador).val().length==0){
						valido = false;
						break;
					}
				}
			}
		}

		if(agregar){
			return valido;
		}

		if(valido){
			$("#btn_registrar").removeClass('btn-general-inactive');
			$("#btn_registrar").addClass('btn-general-active');
			$("#btn_registrar").attr('disabled', false);
		}else{
			$("#btn_registrar").addClass('btn-general-inactive');
			$("#btn_registrar").removeClass('btn-general-active');
			$("#btn_registrar").attr('disabled', true);
		}
	}

	/*
	 * Funciones para quitar operadores en los resultados de la búsqueda
	 */
	// Mostrar u ocultar el mini-formulario
	$(".icoEliminaOperador").click(function(){
		$('.baz').hide('fast');
		o=parseInt($(this).attr('id-operador'));
		$('#operator-'+o).show('slow');
	});
	// Llamar al back
	$(".btnEliminaOperador").click(function(e){
		e.preventDefault;
		i=$(this).attr('id');
		ar=i.split('-');
		o=parseInt(ar[2]);
		if(window.confirm("¿Deseas eliminar al operador " + $('#nbOperador-'+ o).val() + "?")){
			if(/*$('#txOficio-'+o).val()!=="" &&*/ $('#txObservacion-'+o).val()!==""){
				$.ajax({
					type: 'DELETE',
					url: base_url+'/backoffice/operador/eliminar/'+o,
					headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
					data: ({
						id:o,
						txOficio:$('#txOficio-'+o).val(),
						txObservacion:$('#txObservacion-'+o).val(),
					}),
					success: function(data){
						$('.oculta-'+o).hide('slow', function(){$('.oculta-'+o).remove()});
						crearMensaje(false,"Mensaje",data.success);
					},	
					error: function( jqXhr, textStatus, errorThrown ){
						crearMensaje(true,"Error","No pudimos eliminar al operador. ("+errorThrown+")");
					}
				});
			}else{
				crearMensaje(true,"Error","Debes introducir una observación para poder eliminar al operador.");
				$('#txObservacion-'+o).focus();
			}
		}
	});

	/**
	 * Imprimir los detalles
	 */
	$(".icoImprimir").click(function(){
		_placa=$(this).attr('tx-placa');
		url=base_url+'/backoffice/placa/detalle/'+_placa+'/pdf';
		if(!window.open(url,'winPDF')){
			crearMensaje(true,"Error","Un bloqueador de ventanas emergentes impidió que mostraramos los detalles");
		}
	});

	/**
	 * Mostrar Tab correcto al cargar resultados de búsqueda
	 */
	var urlParams = new URLSearchParams(window.location.search);
	if(urlParams.has('tab')){
		tab=urlParams.get('tab');
		$('#busquedas a[href="#'+tab+'"]').tab('show');
	}else{
		$('#busquedas a[href="#placa"]').tab('show');
	}

});
